const Lang = require('lang');

exports.init = function Pesquisa() {
  let isSubmitting = false;
  const form = $('#survey');
  const submitButton = $('#survey button[type=submit]');
  submitButton.prop('disabled', false);
  const modal = $('#pesquisa');

  /**
   * Quando o form for enviado verifica se os radio buttons obrigatórios
   * foram selecionados, se não foram uma mensagem é mostrada abaixo das opções
   */
  form.on('submit', () => {
    // Caso já tenha tenha sido respondido, retorna falso e cancela o envio
    if (isSubmitting) {
      return false;
    }

    // Remove todas mensagens de erro dos radio-groups
    $('.radio-group-error').remove();

    // Caso tenha clicado para não responder, envia o formulário
    if (form.data('noAnswer')) {
      isSubmitting = true;
      return true;
    }

    // Grupos de opções
    const groups = $('.radio-group-required');
    let canSubmit = true;

    // Percorre todos os radio-groups
    groups.each((key, group) => {
      // Ignora o radio-group escondido
      if ($(group).is(':hidden')) {
        return;
      }

      const inputs = $(group).find('input[type=radio],input[type=checkbox]');
      let isChecked = false;

      // Percorre todos os radio buttons e verifica se algum foi selecionado
      inputs.each((key, input) => {
        if ($(input).is(':checked')) {
          isChecked = true;
          return false;
        }
      });

      // Se nenhuma opção foi selecionada
      if (!isChecked) {
        canSubmit = false;

        // Adiciona a mensagem de erro abaixo do radio-group
        $(group).append(`
          <span class="radio-group-error help-block" style="color: #a94442">
            ${Lang.get('js/common/phrases.options_required')}
          </span>
        `);
      }
    })

    // Impede de enviar mais de um request
    if (canSubmit && form.valid()) {
      isSubmitting = true;
    }

    return canSubmit;
  });

  /**
   * Lida com o clique nas opções do radio-group, removendo a mensagem de
   * campo obrigatório caso houver uma nesse radio-group
   */
  $('.modal-radio-group .btn').on('click', function () {
    const group = $(this).closest('.radio-group-required');
    $(group).find('.radio-group-error').remove();

    $(group).find('.btn').removeClass('active');
    $(this).addClass('active');
  });

  /**
   * Caso o usuário informe que não quer responder, essa função impede o envio
   * múltiplo do formulário e envia o formulário sem respostas
   */
  $('.no-answer').on('click', () => {
    if (isSubmitting) {
      return;
    }

    // Adiciona o atributo no form para não validar os radio-groups no submit
    form.attr('data-no-answer', true);

    // Desabilita todos os campos do formulário exceto os necessários para a request
    $('#survey :input')
      .not('input[name=_token], input[name=uuidPesquisa], input[name=identificador]')
      .prop('disabled', true)

    form.trigger('submit');
  });

  /**
   * Fecha o modal ao clicar em algum elemento com a classe close-modal
   */
  $('.close-modal').on('click', () => { modal.remove(); });

  /**
   * Retorna um booleano de acordo com o parâmetro
   *
   * @param {int} value
   * @returns bool
   */
  function parseBool(value) {
    return parseInt(value);
  }

  /**
   * Pesquisa sobre uso de cartão corporativo
   */
  $('input[type=radio][name*="cartao"]').on('change', function () {
    const utilizaCartao = parseBool($(this).val());

    if (utilizaCartao) {
      $('#pesquisa-bancos :input').prop('disabled', false);
      $('#pesquisa-bancos').removeClass('hidden');
    } else {
      $('#pesquisa-bancos :input').prop('disabled', true);
      $('#pesquisa-bancos').addClass('hidden');
    }
  });

  /**
   * Pesquisa sobre uso de cartão corporativo V2
   */
  $('input[type=radio][name*="usamCartoesCorporativos"]').on('change', function () {
    const utilizaCartao = parseBool($(this).val());

    if (utilizaCartao) {
      $('.se-usarem-cartoes :input').prop('disabled', false);
      $('.se-usarem-cartoes').removeClass('hidden');
    } else {
      $('.se-usarem-cartoes :input').prop('disabled', true);
      $('.se-usarem-cartoes').addClass('hidden');
    }
  });

  /**
   * Pesquisa de avaliação do NPS
   */
  $('input[type=radio][name*="notaNPS"],input[type=radio][name*="nota"]').on('change', function () {
    const nota = parseInt($(this).val());
    if (nota < 7) {
      $('#nps-good, #nps-better').addClass('hidden');
      $('#nps-bad').removeClass('hidden');
    } else if (nota < 9) {
      $('#nps-bad, #nps-good').addClass('hidden');
      $('#nps-better').removeClass('hidden');
    } else {
      $('#nps-bad, #nps-better').addClass('hidden');
      $('#nps-good').removeClass('hidden');
    }
    $('#nps-comentario').removeClass('hidden');
  });
};
